import React from "react";
import { PiComputerTowerBold } from "react-icons/pi";
import { BsClipboard2PulseFill } from "react-icons/bs";
import { LuFlower } from "react-icons/lu";
import { LuHeartHandshake } from "react-icons/lu";

const Tretmentwork = () => {
  return (
    <>
      <div className="flex  flex-wrap mt-14 justify-center gap-2">
        <div className="h-[250px]  w-[290px] sm:h-[270px] sm:w-[200px] md:h-[270px] md:w-[290px] text-center px-2 flex flex-col justify-center items-center  border border-[#469B8F]  shadow-md shadow-[#469B8F] rounded-3xl ">
          <PiComputerTowerBold className="text-[#469B8F]  p-1 text-7xl" />
          <span className="font-roboto mt-2 text-2xl">Appointment</span>
          <p className="font-roboto text-xl sm:text-lg mt-3 font-normal ">
            "Before we can proceed, you'll need to make an appointment at the
            hospital."
          </p>
        </div>

        <div className="h-[250px] w-[290px] sm:h-[270px] sm:w-[200px] md:h-[270px] text-center md:w-[290px] px-2 flex flex-col justify-center items-center  border border-[#469B8F]  shadow-md shadow-[#469B8F] rounded-3xl">
          <BsClipboard2PulseFill className="text-[#469B8F] p-1 text-7xl" />
          <span className="font-roboto mt-2 text-2xl">Consultation</span>
          <p className="font-roboto text-xl sm:text-lg mt-3 font-normal">
            "Scheduling a consultation is the first step toward getting the help
            and support you need."
          </p>
        </div>

        <div className="h-[250px] w-[290px] sm:h-[270px] sm:w-[200px] md:h-[270px] text-center md:w-[290px] px-2 flex flex-col justify-center items-center  border border-[#469B8F]  shadow-md shadow-[#469B8F] rounded-3xl ">
          <LuHeartHandshake className="text-[#469B8F] p-1 text-7xl " />
          <span className="font-roboto mt-2 text-2xl">Session</span>
          <p className="font-roboto text-xl sm:text-lg mt-3 font-normal">
            "The session will focus on discussing your current concerns and
            possible treatment approaches."
          </p>
        </div>

        <div className="h-[250px] w-[290px] sm:h-[270px] sm:w-[200px] md:h-[270px] text-center md:w-[290px] px-2 flex flex-col justify-center items-center  border border-[#469B8F]  shadow-md shadow-[#469B8F] rounded-3xl">
          <LuFlower className="text-[#469B8F] p-1 text-7xl " />
          <span className="font-roboto mt-2 text-2xl">Evaluation</span>
          <p className="font-roboto text-xl sm:text-lg mt-3 font-normal">
            "The evaluation is simply a first step to get a clearer picture of
            what you’re going through."
          </p>
        </div>
      </div>
    </>
  );
};

export default Tretmentwork;
